var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-content lili-flex align-center space-between" },
    [
      _c("span", {
        staticClass: "main-logo",
        on: {
          click: function($event) {
            return _vm.$router.push("/")
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "progress-wrapper lili-flex align-center" }, [
        _c("span", {
          staticClass: "progress-fill",
          style: { width: this.$store.getters["ob/getProgFillWidth"] }
        })
      ]),
      _vm._v(" "),
      _vm.isGoBack && !_vm.$store.state.editMode
        ? _c("span", {
            staticClass: "go-back",
            attrs: { id: "back" },
            on: { click: _vm.handlRouterBack }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "top-spacer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32c95b2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c95b2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcomeComponents/TopContent.vue
// module id = null
// module chunks = 